import React from "react";
import { motion } from "framer-motion";
import { TrendingUpIcon, TrendingDownIcon } from "@heroicons/react/outline";

const StatCard = ({
  title,
  value,
  icon: Icon,
  color = "primary",
  change = 0,
}) => {
  const colors = {
    primary: "bg-primary-50 dark:bg-primary-900/20 text-primary-500",
    success: "bg-green-50 dark:bg-green-900/20 text-green-500",
    warning: "bg-yellow-50 dark:bg-yellow-900/20 text-yellow-500",
    danger: "bg-red-50 dark:bg-red-900/20 text-red-500",
    info: "bg-blue-50 dark:bg-blue-900/20 text-blue-500",
  };

  const isPositive = change > 0;
  const isNegative = change < 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="card hover:shadow-lg transition-shadow duration-300"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
            {title}
          </p>
          <p className="text-2xl md:text-3xl font-bold text-slate-900 dark:text-white mt-1">
            {value}
          </p>
        </div>
        <div className={`p-3 rounded-xl ${colors[color]}`}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
      {change !== 0 && (
        <div className="flex items-center gap-1 mt-3">
          {isPositive ? (
            <TrendingUpIcon className="h-4 w-4 text-green-500" />
          ) : isNegative ? (
            <TrendingDownIcon className="h-4 w-4 text-red-500" />
          ) : null}
          <span
            className={`text-xs font-medium ${
              isPositive
                ? "text-green-500"
                : isNegative
                  ? "text-red-500"
                  : "text-slate-500"
            }`}
          >
            {isPositive ? "+" : ""}
            {change}%
          </span>
          <span className="text-xs text-slate-500 dark:text-slate-400">
            from last period
          </span>
        </div>
      )}
    </motion.div>
  );
};

export default StatCard;
